import {gt} from 'app/utils/i18n';

import type {AIPromptExampleType} from 'app/openai/types';

export const PLACEHOLDERS = {
  edit_procedure_chat: [
    gt(
      'Hi SweetAI, could you help me update the title of this procedure to something more engaging?'
    ),
    gt(
      "Hello SweetAI! I'd like to enhance the procedure description to make it more detailed. Can you suggest some improvements?"
    ),
    gt(
      'Hey SweetAI, I think we need to add a new step to this procedure. Do you have any recommendations for what might be missing?'
    ),
    gt(
      'Hi SweetAI! Could you help me update one of the step titles to make it clearer?'
    ),
    gt(
      'Hello SweetAI, I believe one of the step descriptions could be more detailed. Could you review and suggest some improvements?'
    ),
    gt(
      'Hi SweetAI, can you review this procedure and suggest any areas that could be improved?'
    ),
    gt(
      'Hey SweetAI, could you proofread the entire procedure and optimize it for better clarity and flow?'
    ),
    gt(
      'Hi SweetAI, can you check this procedure to ensure it complies with our guidelines and policies?'
    ),
    gt(
      'Hello SweetAI, could you help tailor this procedure to a more specific audience? Any suggestions would be helpful.'
    ),
    gt(
      'Hey SweetAI, I think some steps in this procedure are too complex. Can you suggest simpler alternatives?'
    ),
    gt(
      'Hi SweetAI, could you add a table of responsibilities to the procedure description? We need to specify who handles each part of the process.'
    ),
    gt(
      "Hello SweetAI! I'd like to update the table of responsibilities in the description. Can you help me ensure it's accurate and up-to-date?"
    ),
    gt(
      'Hey SweetAI, I think adding a table of responsibilities would enhance the clarity of this procedure. Could you assist with that?'
    ),
    gt(
      'Hi SweetAI, could you review the current table of responsibilities in the description and suggest any improvements or corrections?'
    ),
    gt(
      "Hello SweetAI, let's organize the responsibilities more clearly. Can you create a table in the description to outline this?"
    ),
  ],
  edit_policy_chat: [
    gt(
      'Hi SweetAI, could you help me update the title of this policy to something more engaging?'
    ),
    gt(
      'Hi SweetAI, can you review this policy and suggest any areas that could be improved?'
    ),
    gt(
      'Hey SweetAI, could you proofread the entire policy and optimize it for better clarity and flow?'
    ),
    gt(
      'Hello SweetAI, could you help tailor this policy to a more specific audience? Any suggestions would be helpful.'
    ),
    gt(
      'Hey SweetAI, I think this policy is too complex. Can you suggest simpler alternatives?'
    ),
  ],
};

export const PROMPTS: Record<
  'edit_policy_chat' | 'edit_procedure_chat',
  Array<AIPromptExampleType>
> = {
  edit_procedure_chat: [
    {
      name: 'Find and replace',
      prompt: `Hi SweetAI, please find 'term to replace' and replace it with 'replacement term' in the procedure name, description, step names, and step content.
      `,
    },
    {
      name: 'Comprehensive Procedure Description',
      prompt: `
        SweetAI, please create a detailed description for this procedure. Include the following elements:
        - Purpose: Explain why the procedure exists and its importance.
        - Scope: Define who should follow the procedure and under what circumstances.
        - Important Notes: Highlight any critical points, conditions, or exceptions that should be considered.

        Ensure the description is concise yet comprehensive so that readers quickly understand
        the scope and significance of the procedure before they proceed to the detailed steps.
      `,
    },
  ],
  edit_policy_chat: [
    {
      name: 'Find and replace',
      prompt: `Hi SweetAI, please find 'term to replace' and replace it with 'replacement term' in the policy name and content.`,
    },
    {
      name: "Replace 'Company' With Your Company Name",
      prompt: `Please replace the placeholder word 'Company' with [Your Company Name].`,
    },
    {
      name: 'Add Multi-Level Numbering to Headings',
      prompt: `Please add multi-level numbering to the headings elements in the policy. Do not extend multi-level numbering to paragraphs. For example:
1. Main Heading
   1.1 Sub Heading
       1.1.1 Sub-Sub Heading
        Paragraph text goes here
   1.2 Another Sub Heading
2. Another Main Heading
   2.1 Sub Heading
  paragraph text here`,
    },
  ],
};
